import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { environment } from 'environments/environment';

import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class UiService {
    loadingStateChanged = new Subject<boolean>();
    routeLoadingStateChanged = new Subject<boolean>();
    translationLoadingStateChanged = new Subject<boolean>();

    private appName: string = environment.appName;

    constructor(
        private snackbar: MatSnackBar,
        private dialog: MatDialog,
        private translateSrv: TranslateService,
        private titleSrv: Title,
    ) { }

    showSnackbar(message: string, isTranslated = false, duration = 3000, action = null): void {
        if (isTranslated) {
            this.translateSrv.get(message).subscribe(text => {
                this.snackbar.open(text, action, { duration: duration });
            });
        } else {
            this.snackbar.open(message, action, { duration: duration });
        }
    }

    confirmDialog(message?: string): MatDialogRef<ConfirmDialogComponent> {
        if (!message) {
            message = this.translateSrv.instant('main.dialogs.confirm.summary');
        } else {
            message = this.translateSrv.instant(message);
        }

        return this.dialog.open(ConfirmDialogComponent, {
            // Send data to the dialog
            data: {
                message: message
            }
        });
    }

    changeTitle(translationCode: string): void {
        new Promise(resolve => {
            return this.translateSrv.get(translationCode)
                .subscribe(result => {
                    return resolve(result);
                });
        }).then((title: string) => {
            this.titleSrv.setTitle(this.appName + ' - ' + title);
        });
    }

    translate(key: string): string {
        return this.translateSrv.instant(key);
    }

    getChartsColors(): string[] {
        return [
            '#af1e3c',
            '#faafa0',
            '#dc1e5f',
            '#ffdae1',
            '#f03241',
            '#979faa',
            '#8c193c',
            '#ebebe6',
            '#5a0037',
            '#e8ebed',
            '#d2d2d7',
        ];
    }
}
